import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin", { replace: true });
      return;
    }
    const sessionId = m[1];

    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        // Clean the hash and route to admin
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (e) {
        console.error("Auth exchange failed", e);
        navigate("/admin?auth=failed", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#0B0A08" }}>
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#C8A258]/30 border-t-[#C8A258] rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#EDE3CF]/80 font-display text-xl">Connexion en cours...</p>
      </div>
    </div>
  );
}
